import React from 'react';
import logo from '../../images/logo/actfit-logo-triangle-blue.svg';

const BlueLogoIcon = () => (
  <img src={logo} className="BlueLogoIcon" alt="logo" />
);

export default BlueLogoIcon;



// WEBPACK FOOTER //
// ./src/components/logo/blueLogoIcon.js